import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { useToast } from "../toast";
import CloseIcon from "@mui/icons-material/Close";
import { removeVehiclesForSdvFeature } from "../../services/SdvFeature";

const DeleteVehicleFeatureDialog = (props) => {
  const { addToast } = useToast();
  const queryClient = useQueryClient();
  const { id, name, selectedRows, toggleDialog } = props;

  const { mutate: removeVehiclesFromFeature, isLoading } = useMutation(
    removeVehiclesForSdvFeature,
    {
      onSuccess: async () => {
        addToast({
          type: "success",
          message: `Vehicles Removed From Feature successfully.`,
          autoClose: 3000,
        });
        toggleDialog();
      },
      onError: (e) => {
        const { response } = e;
        addToast({
          type: "error",
          message: response?.data?.message || "Failed to create",
          autoClose: 3000,
        });
      },
      onSettled: () => {},
    }
  );

  const onConfirm = () => {
    const payload = {
      data: {
        sdvFeatureId: id,
        vehicleKey: selectedRows,
      },
    };
    removeVehiclesFromFeature(payload);
    //toggleDialog();
  };
  const onCancel = () => {
    toggleDialog();
  };
  return (
    <Dialog
      open={!!id}
      onClose={onCancel}
      aria-labelledby="delete-confirm-dialog-title"
      aria-describedby="delete-confirm-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {`Confirm Delete`}
        <IconButton
          aria-label="close"
          onClick={toggleDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Tooltip title="Close delete dialog">
            <CloseIcon />
          </Tooltip>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Do you really want to delete the vehicles from ${name}"?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteVehicleFeatureDialog;
